import React, { useEffect, useState } from "react";
import { Tab, Tabs, Paper, Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { ContainerBg } from "../../useGeneralStyles";

import TabPanel from "../../components/ui/TabPanel";
import FundedTradersTable from "./components/FundedTradersTable";
import { SERVICE_API_URLS, ServiceAPI } from "../../api/service";
import { fundedTradersStatusesListActions } from "../../reducers/fundedTradersStatusesList";

const FundedTraders = (): React.ReactElement => {
  const dispatch = useDispatch();
  const [activeTabIndex, setActiveTab] = useState(0);

  const onChangeActiveTab = (_: React.BaseSyntheticEvent, newValue: number) =>
    setActiveTab(newValue);

  const { isError, error } = useQuery({
    queryKey: [SERVICE_API_URLS.getFundedTradersStatusesList],
    queryFn: async () => {
      dispatch(fundedTradersStatusesListActions.fetchListRequest());
      const response = await ServiceAPI.getFundedTradersStatusesListRequest();
      dispatch(fundedTradersStatusesListActions.fetchListSuccess(response.data));
      return response.data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(fundedTradersStatusesListActions.fetchListFailed());
    }
  }, [isError, error]);

  return (
    <ContainerBg>
      <div>
        <Paper square>
          <Tabs value={activeTabIndex} onChange={onChangeActiveTab}>
            <Tab label="Funded Traders" />
            <Tab label="LiveSim" />
            <Tab label="Live" />
            {/*<Tab label="Forced Live" />*/}
          </Tabs>
        </Paper>
      </div>

      <Box sx={{ pt: "10px" }}>
        <TabPanel value={activeTabIndex} index={0}>
          <FundedTradersTable account_type="all" />
        </TabPanel>
        <TabPanel value={activeTabIndex} index={1}>
          <FundedTradersTable evaluation_type="LiveSim" />
        </TabPanel>
        <TabPanel value={activeTabIndex} index={2}>
          <FundedTradersTable evaluation_type="Live" />
        </TabPanel>
        {/*<TabPanel value={activeTabIndex} index={3}>*/}
        {/*  <FundedTradersTable account_type="forcedToLive" />*/}
        {/*</TabPanel>*/}
      </Box>
    </ContainerBg>
  );
};

export default FundedTraders;
